import { render, staticRenderFns } from "./ComparisonChart.vue?vue&type=template&id=1c8e0d20&"
import script from "./ComparisonChart.vue?vue&type=script&lang=ts&"
export * from "./ComparisonChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports